import React from 'react';
import { LegalPage } from '../components/platform/LegalPage';
import { PRIVACY } from '../content/legal';

export default function PrivacyPolicy() {
  return (
    <LegalPage testId="privacy-policy-page" title="Privacy Policy" sections={PRIVACY}
      intro="How DecoWorkflow collects, uses and protects information across our marketing website, demo bookings, CRM subscriptions and the branded websites we host for subscribing print shops." />
  );
}
